import { render } from "./CollectionReport.vue?vue&type=template&id=2e79494e&scoped=true"
import script from "./CollectionReport.vue?vue&type=script&lang=js"
export * from "./CollectionReport.vue?vue&type=script&lang=js"

import "./CollectionReport.vue?vue&type=style&index=0&id=2e79494e&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e79494e"]])

export default __exports__